const jQuery = require('jquery');

export function promoGate(){

    if( jQuery(".promo-gate").length ){
        //cache some jQuery objects
        const transitionLayer = jQuery('.promo-gate-transition-layer');
        const modalWindow     = jQuery('.promo-gate');
        const prefix          = modalWindow.data('prefix');
        const reappear        = modalWindow.data('reappear');

        //open modal window
        jQuery(window).on('scroll', function() {

            const myCookie       = jQuery.cookie('hide-promo-gate-' + prefix);
            const scrollPosition = jQuery(this).scrollTop();

            if (scrollPosition >= 300 && !myCookie) {	
                transitionLayer.addClass('visible opening');
                const delay = ( jQuery('.no-cssanimations').length > 0 ) ? 0 : 600;
                setTimeout(function(){
	                modalWindow.addClass('visible');
                }, delay);
            }
        });

        //open modal with nav button
        jQuery("#main-navigation-alert").on( "click", function() {
            transitionLayer.addClass('visible opening');
            const delay = ( jQuery('.no-cssanimations').length > 0 ) ? 0 : 100;
            setTimeout(function(){
                modalWindow.addClass('visible');
            }, delay);
        });
	

        //close modal window
        modalWindow.on('click', '.promo-gate-close-' + prefix, function(){
            transitionLayer.addClass('closing');
            modalWindow.removeClass('visible');
            jQuery.cookie('hide-promo-gate-' + prefix, '1', reappear);
        });
    }
}

